import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { useSelector, useDispatch } from "react-redux";
import PaymentBlock from "./PaymentBlock";
import CouponCode from "./CouponCode";
import { useState, useCallback, useRef, useEffect } from "react";
import { ConfirmDialog, CustomButton, CustomIconButton } from "@/src/lib/ui";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import Progressbar from "@/src/components/loading";
import { useToast } from "@/src/lib/hooks/useToast";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
// import DateTime from "../date-time";

import {
    NEXT_PUBLIC_LOGO,
    NEXT_PUBLIC_RAZORPAY_KEY,
} from "@/src/lib/util/config";
import { loadScript } from "@/src/components/common/common";
import { resetAppointment } from "@/src/lib/store/pet-ct-appointment-new/slice";
import ConfirmAppointment from "./ConfirmAppointment";
import DateTime from "../date-time";

// const DateTime = dynamic(() => import("../date-time"));
// const ConfirmAppointment = dynamic(() => import("./ConfirmAppointment"), {
//     ssr: false,
// });

const PaymentConfirmation = () => {
    const [open, setOpen] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const appointmentDetials = useSelector((state) => state?.appointmentNew);
    const [isApplyCoupon, setIsApplyCoupon] = useState("");
    const [openCoupon, setOpenCoupon] = useState(false);
    const router = useRouter();
    const PAYMENT_METHOD = 9;

    const dispatch = useDispatch();
    const { showCustomToast } = useToast();
        const iframeRef = useRef(null);
    const paymentDetails = appointmentDetials?.centreDetails;
    const AdvancePayment = Number(
        appointmentDetials?.centreDetails?.advRequired || 0
    );
    const [advancePayment, setAdvancePayment] = useState(AdvancePayment);

    const discountAmount = appointmentDetials?.discountAmount;
    const mobileNo = appointmentDetials?.mobileNo;

    const totalAmount = useSelector((state) =>
        Number(state.appointmentNew.centreDetails?.rate || 0)
    );

    const { mutate: validateTimeSlotMutate, isLoading: isValidatingTimeSlot } =
        useHODMutation((data) => cartApiService.getValidateTimeSlot(data), {
            onSuccess: (data) => {
                if (!!data?.slotValid) {
                    const payload = {
                        checkoutId: appointmentDetials?.checkoutId,
                        mobileNo: Number(mobileNo),
                        paymentInfo: {
                            method: PAYMENT_METHOD === 9 ? "juspay" : "razorpay",
                            amount: advancePayment,
                        },
                    };

                    completeCheckoutMutate(payload);
                } else {
                    setOpenConfirm(true);
                    showCustomToast(
                        "The selected time slot is currently unavailable. Please choose another one..",
                        "error"
                    );
                }
            },
            onError: (error) => {
                showCustomToast(
                    error?.response?.data?.message || error?.message,
                    "error"
                );
                console.log(
                    error?.response?.data?.message || error?.message,
                    "error====================="
                );
            },
        });

    const { mutate: completeCheckoutMutate, isLoading: isCompletingCheckout } =
        useHODMutation((data) => cartApiService.getCompleteCheckout(data), {
            onSuccess: async (data) => {


                if(PAYMENT_METHOD === 9){
                    setPaymentMethod(data?.paymentData?.payment_links?.web)

                }

                else {

                      const scriptLoaded = await loadScript(
                    "https://checkout.razorpay.com/v1/checkout.js"
                );

                if (
                    !scriptLoaded ||
                    typeof window === "undefined" ||
                    typeof window.Razorpay !== "function"
                ) {
                    showCustomToast(
                        "Unable to load payment gateway. Please check your internet connection and try again.",
                        "error"
                    );
                    return;
                }

                const options = {
                    key: NEXT_PUBLIC_RAZORPAY_KEY,
                    amount: data?.amount * 100,
                    currency: "INR",
                    name: "HOD",
                    description: "House Of Diagnostics",
                    image: NEXT_PUBLIC_LOGO, //Add your logo image path
                    order_id: data?.generatedOrderId, //Order ID from Razorpay
                    prefill: {
                        name: data?.info?.pname,
                        email: data?.info?.email,
                        contact: data?.info?.mobile,
                    },
                    handler: function (response) {
                        if (data?.orderToken) {
                            setOpen(data?.orderToken);
                        }
                        //Here you can call a function to update payment status on your server
                    },

                    theme: {
                        color: "#c50001",
                    },
                };

                const rzp = new window.Razorpay(options);
                rzp.open();

                }


              
            },
            onError: (error) => {
                showCustomToast(
                    error?.response?.data?.message || error?.message,
                    "error"
                );
                console.log(error, "error=====================");
            },
        });

    const bookNowHandler = () => {
        if (Number(advancePayment) < AdvancePayment) {
            showCustomToast(
                "Advance Payment cannot be less than the minimum advance payable",
                "error"
            );

            setAdvancePayment(AdvancePayment);
            return;
        }
        if (Number(advancePayment) > totalAmount) {
            showCustomToast(
                "Advance Payment cannot be greater than Total cost of the test",
                "error"
            );
            setAdvancePayment(AdvancePayment);
            return;
        }

        const formattedTime =
            appointmentDetials?.selectedDateTime?.slotTime?.split(".")[0] ||
            null;

        const payload = {
            preferredDate: appointmentDetials?.selectedDateTime?.date,
            preferredTime: formattedTime,
            testId: appointmentDetials?.testDetails?.itemId,
            centreId: appointmentDetials?.centreDetails?.centreId,
            validationType: "selectedSlot",
        };

        validateTimeSlotMutate(payload);
    };

    const onClose = () => {
        setOpen(null);
        dispatch(resetAppointment());
    };

    const dateTimeCloseHandler = useCallback(() => {
        setOpenConfirm(false);
    }, []);

    const couponCloseHandler = useCallback(() => {
        setOpenCoupon(false);
    }, []);

    const paymentMethodCloseHandler = useCallback(() => {
        setPaymentMethod(null)
    }, []);

    return (
        <div className="max-w-xl mx-auto">
            <div className="flex justify-between items-center md:mt-12 mt-4 md:mb-3 mb-2">
                <p className="text-xs uppercase tracking-widest text-black font-medium ">
                    Payment Confirmation
                </p>

                <div
                    onClick={() => setOpenCoupon(true)}
                    className="bg-white shadow-md p-2 rounded-md border-2 border-dashed border-primary hover:bg-primary cursor-pointer group flex flex-row justify-between"
                >
                    <div className="text-primary flex items-center cursor-pointer">
                        <Iconify
                            icon={IconCode.offer}
                            width={16}
                            className="mr-2 group-hover:text-white"
                        />
                        <p className="uppercase font-bold group-hover:text-white text-xs">
                            Apply Coupon
                        </p>
                    </div>

                    <Iconify
                        className="text-primary -rotate-90 group-hover:text-white"
                        icon={IconCode.arrowDown}
                        width={18}
                    />
                </div>
            </div>

            <div className="bg-white md:p-4 p-2 shadow-md">
                {/* <CustomButton
                    fullWidth
                    variant="outlined"
                    className="px-6 py-3 mb-4"
                    onClick={() => setOpenCoupon(true)}
                >
                    Apply Coupon
                </CustomButton> */}
                <div className="grid">
                    {/* <div className="flex justify-center items-center flex-col border border-gray-200  p-3">
                        <p className="block md:text-lg text-base font-semibold text-gray-600 md:mb-0 mb-1">
                            Advance Payment
                        </p>
                        <div className="flex flex-row items-center md:gap-2 gap-1">
                            <div>
                                <Iconify
                                    icon={IconCode.rupeeBold}
                                    width={40}
                                    className="text-primary"
                                    height={40}
                                />
                            </div>
                            <div className="md:text-7xl text-5xl font-bold">
                                {paymentDetails?.advRequired}
                            </div>
                        </div>
                        <p className="text-primary mt-2 text-center md:text-base text-sm">
                            Note: An advance payment of{" "}
                            <strong>₹{paymentDetails?.advRequired}</strong> will
                            be charged.
                        </p>
                    </div> */}
                    <div>
                        {discountAmount > 0 && (
                            <div className="flex flex-row items-center gap-2 bg-green-100 p-2 rounded-md mb-4 justify-between border-2 border-dashed border-green-600">
                                <p className="text-green-600 text-sm text-center">
                                    Coupon{" "}
                                    <span className="font-bold text-green-600">
                                        {`"${isApplyCoupon}"`}
                                    </span>{" "}
                                    has been applied successfully
                                </p>
                            </div>
                        )}

                        <PaymentBlock
                            discountAmount={discountAmount}
                            setAdvancePayment={setAdvancePayment}
                            advancePayment={advancePayment}
                        />
                    </div>
                </div>
                <div className="flex justify-end">
                    <CustomButton
                        variant="contained"
                        disabled={isCompletingCheckout || isValidatingTimeSlot}
                        onClick={bookNowHandler}
                        className="bg-primary text-white px-6 py-3"
                    >
                        {isCompletingCheckout || isValidatingTimeSlot ? (
                            <Progressbar size={16} color="white" />
                        ) : (
                            `Pay ₹ ${advancePayment} Now`
                        )}
                    </CustomButton>
                </div>
            </div>

            {!!open && (
                <ConfirmDialog
                    maxWidth="xl"
                    onClose={onClose}
                    open={!!open}
                    isCancel={true}
                    content={
                        <ConfirmAppointment
                            paymentId={open}
                            onClose={onClose}
                        />
                    }
                />
            )}



{!!paymentMethod &&
   (  <ConfirmDialog
                    maxWidth="5xl"
                   onClose={paymentMethodCloseHandler}
                    open={paymentMethod}
                    isCancel={true}
                    className="max-w-5xl w-full"
                    content={
                       <iframe
                     ref={iframeRef}
                        src={paymentMethod}
                        title="JusPay Payment"
                        className="w-full"
                      style={{ border: 0, width: "100%", height: "520px" }}
                        allow="payment *;"
                    />
                    }
                />
   )
}
            {openConfirm && (
                <ConfirmDialog
                    maxWidth="2xl"
                    onClose={dateTimeCloseHandler}
                    open={openConfirm}
                    isCancel={true}
                    className="max-w-4xl w-full"
                    content={
                        <DateTime
                            onClose={dateTimeCloseHandler}
                            confirmTimeSlot={true}
                        />
                    }
                />
            )}

            {openCoupon && (
                <ConfirmDialog
                    maxWidth="2xl"
                    onClose={couponCloseHandler}
                    open={openCoupon}
                    title={
                        <>
                            <p className="text-lg font-bold text-primary">
                                Apply Coupon
                            </p>
                            <p className="text-sm text-gray-600 mb-2 ">
                                Enter the coupon code to get a discount on your
                                appointment.
                            </p>
                        </>
                    }
                    isCancel={true}
                    className="max-w-md w-full"
                    content={
                        <CouponCode
                            setIsApplyCoupon={setIsApplyCoupon}
                            onClose={couponCloseHandler}
                        />
                    }
                />
            )}
        </div>
    );
};

export default PaymentConfirmation;